import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '@unicup-ticketing/auth';
import { map } from 'rxjs';

export const LoginRedirect: CanActivateFn = (route, state, service = inject(AuthService), router = inject(Router)) => {
  // If the callback could not be completed (error from the identity provider, missing code, reload of the callback
  // url) there is nothing to show on this route, so fall back to the start page instead of cancelling the navigation.
  return service.handleLoginRedirect().pipe(map(success => success || router.parseUrl('/')));
};
